<div class="d-flex justify-content-between mt-4">
  <div class=" mt-2" style="margin-left:1%;">
    <a ><img src="../../../assets/img/FreeMove_2023_Logo-website_slogan.png" class="header-logo">
    </a>
  </div>
  
  <div style="margin-right: 4%;" class="d-flex flex-row mt-2">
    <a ><img src="../../../assets/img/orhange-logo.svg" class="header-members">
    </a>
    <a style="margin-left:4%;"><img src="../../../assets/img/tim-logo.svg" class="header-members">
    </a>
    <a style="margin-left:4%;"><img src="../../../assets/img/T_logo_rgb_p.svg" class="header-members">
    </a>
    <a style="margin-left:4%;"><img src="../../../assets/img/telia-logo.svg" class="header-members">
    </a>
  </div>
  
</div>

<nav style="background: #f4f4f4; width:auto;" class="navbar navbar-expand-lg navbar-light bg-light mt-2">

  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="d-flex justify-content-between mt-3" style="list-style:none; padding: 0px; margin: none!important;">
        <li class="nav-item" style="  display: inline-block; white-space: nowrap ;">
          <a  class="nav-link active a-style-nav"
            [ngClass]="{'a-style-nav-active': pageActiveName && pageActiveName=='/management-users' }"
            [routerLink]="['/management-users']" routerLinkActive="active">Users
            Management </a>
        </li>
        <li class="nav-item" style="margin-left: 5%;  display: inline-block; white-space: nowrap ;">
          <a  class="nav-link active a-style-nav"
          [ngClass]="{'a-style-nav-active': pageActiveName && (pageActiveName=='/local-agreements-view') }"
          [routerLink]="['/local-agreements-view']" routerLinkActive="active">Agreement 
          </a>
        </li>
        <li class="nav-item" style="margin-left: 5%; white-space: nowrap ;">
          <a  class="nav-link active a-style-nav" [routerLink]="['/customer-data-entry']"
          [ngClass]="{'a-style-nav-active': customerNavbarOn  }"
          routerLinkActive="active">Customer 
          </a>
        </li>
        <li class="nav-item" style="margin-left: 5%; white-space: nowrap ;">
          <a  class="nav-link active a-style-nav" [routerLink]="['/catalog-view']"
          [ngClass]="{'a-style-nav-active': catalogNavbarOn }"
          routerLinkActive="active">Catalog  </a>
        </li>
        <li class="nav-item" style="margin-left: 5%; white-space: nowrap ;">
          <a  class="nav-link active a-style-nav" [routerLink]="['/inventory-view']"
          [ngClass]="{'a-style-nav-active': inventoryNavbarOn }"
          routerLinkActive="active">Inventory  </a>
          
        </li>
        <li class="nav-item" style="margin-left: 5%; white-space: nowrap ;">
          <a  class="nav-link active a-style-nav" [routerLink]="['/reporting-view']"
          [ngClass]="{'a-style-nav-active': pageActiveName && pageActiveName=='/reporting-view' }"
          routerLinkActive="active">Reporting </a>
        </li>

      </ul>
    </div>
    <button  class="btn btn-outline-success logout-style" (click)="logout()">LOGOUT</button>

    
  </div>


</nav>

<div class="content">
  <div class="wrapper" id="main" >
    <!-- Spinner-->
    <!-- timer -->
    <!-- ball-clip-rotate -->
    <ngx-spinner name="sp1" style="margin-top: 100px;" bdOpacity=0.9 bdColor="#ffffff" size="default" color="#13589d"
      type="ball-clip-rotate" [fullScreen]="true">
      <p style="color: black;text-align:center;" >
        <img src="../../../assets/img/Freemove_logo.png" width="180" class="d-inline-block align-top" alt=""
          style="margin-top: 20%;"><br>
        <span class="loadingSpinnerTextStyle">Loading...</span>
      </p>
    </ngx-spinner>
    <!-- Fine Spinner-->
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>
</div>